/**
 * 生成随机数
 * @param {any} length
 * @returns {String}
 */
export function randomKey(length = 8) {
  const arr = '0123456789abcdefghijklmnopqrstuvwxyz';
  const len = arr.length;
  let str = '';
  for (let i = 0; i < length; i++) {
    const pos = Math.round(Math.random() * (len - 1));
    str += arr[pos];
  }
  return str;
}

/**
 * 简单对象序列化为字符串
 * @example {name: 'www', age: 30} => 'name=www&age=30'
 * @param {any} [data={}]
 * @returns {String | ''}
 */
export function serialize(data = {}) {
  return Object.keys(data)
    .filter((key) => ![null, '', undefined].includes(data[key]))
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&');
}

// 序列化（新增数组参数处理）
export function serializeDeep(data = {}) {
  return Object.keys(data)
    .filter((key) => ![null, '', undefined].includes(data[key]))
    .map((key) => {
      if (Array.isArray(data[key]) && data[key].length > 0) {
        return data[key].map((value) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`;
    })
    .join('&');
}

/**
 * 过滤无效数据：null, '', [], {}
 * @param {Object} data
 * @returns {Object}
 */
export function filterInvalidData(data) {
  return Object.keys(data)
    .filter((key) => {
      if ([null, ''].includes(data[key])) {
        return false;
      }
      if (Array.isArray(data[key]) && !data[key].length) {
        return false;
      }
      if (JSON.stringify(data[key]) === '{}') {
        return false;
      }
      return true;
    })
    .reduce(
      (obj, key) => ({
        ...obj,
        [key]: data[key],
      }),
      {}
    );
}

// 去除前后空格
// demo = '  例子  ';  demo = trim(demo)
export function trim(str) {
  return str.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, '');
}

// 获取指定的哪一天
export function timeForMat(count) {
  let difference = '';
  const d = new Date(Date.now() + count * 24 * 60 * 60 * 1000);
  const year = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();
  if (!count) {
    return Date.now();
  }
  if (count > 0) {
    difference = -1;
  } else {
    difference = 1;
  }
  return new Date(year, month, day + difference).getTime();
}

// 需除以 1000
export function formatDuring(timestamp) {
  const dayA = timestamp % (24 * 3600); // 除去天数，得到剩余的小时时间戳
  const hourA = dayA % 3600; // 除去小时，得到剩余的分钟数时间戳
  const minuteA = hourA % 60; // 除去分钟，得到剩余的秒数时间戳
  const days =
    Math.floor(timestamp / (24 * 3600)) < 10
      ? '0' + Math.floor(timestamp / (24 * 3600))
      : Math.floor(timestamp / (24 * 3600));
  const hours = Math.floor(dayA / 3600) < 10 ? '0' + Math.floor(dayA / 3600) : Math.floor(dayA / 3600);
  const minutes = Math.floor(hourA / 60) < 10 ? '0' + Math.floor(hourA / 60) : Math.floor(hourA / 60);
  const seconds = Math.floor(minuteA) < 10 ? '0' + Math.floor(minuteA) : Math.floor(minuteA);
  return {
    days,
    hours,
    minutes,
    seconds,
  };
}

// 数值转为千分制
export function comdifySum(n) {
  return (Number(n).toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
}

// 字符串转数字
export function strToNum(str) {
  return str ? +str : '';
}

// 字符串数组转为数字数组
export function toNumArray(arr) {
  return arr ? arr.map((item) => +item) : arr;
}

// 过滤富文本标签
export function richTextFormate(value) {
  if (value.indexOf('<img') !== -1) {
    return value;
  }
  const richText = value.replace(/<[^>]+>/g, '').replace(/\s|[\r\n]|\↵/g, '') ? value : '';
  return richText;
}

export function toChinesNum(num) {
  const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  const unit = ['', '十', '百', '千', '万'];
  num = parseInt(num);
  const getWan = (temp) => {
    const strArr = temp.toString().split('').reverse();
    let newNum = '';
    for (let i = 0; i < strArr.length; i++) {
      newNum =
        (i === 0 && strArr[i] === 0
          ? ''
          : i > 0 && strArr[i] === 0 && strArr[i - 1] === 0
          ? ''
          : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i])) + newNum;
    }
    return newNum;
  };
  const overWan = Math.floor(num / 10000);
  let noWan = num % 10000;
  if (noWan.toString().length < 4) {
    noWan = '0' + noWan;
  }
  return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num);
}

// 根据阿里云的部分图片路径转化为上传图片组件的数组数据
export function formatOssImgUrlToUploadImgData(imgUrl) {
  if (!imgUrl) {
    return [];
  }
  return {
    imageKey: '',
    path: imgUrl,
    miniImageUrl: `${ZP.param.fileServerBaseUrl}${imgUrl}?x-oss-process=image/resize,w_200`,
    imageUrl: `${ZP.param.fileServerBaseUrl}${imgUrl}`,
  };
}
